module.exports = __webpack_public_path__ + "img/violet_030.ac91c9a5.png";